import dayjs from 'dayjs';
import type { ConfigType } from 'dayjs';
import { isString } from 'lodash-es';

const isoWithTzRegexp = /[+-]\d{2}:\d{2}|Z$/;
const isoLikeRegexp = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/;

export function convertToIso(dateStr: ConfigType | undefined) {
  return isString(dateStr) && isoLikeRegexp.test(dateStr) && !isoWithTzRegexp.test(dateStr) ? `${dateStr}Z` : dateStr;
}

export function daysFromToday(date: ConfigType): number {
  return dayjs(convertToIso(date)).diff(Date.now(), 'day');
}

export function convertUnixTimestampToJSTime(timestamp: number): number {
  return timestamp * 1000;
}

export function getTimestamp(date: ConfigType): number {
  const dateValue = Number(date) || convertToIso(date);
  const dateObj = dayjs(dateValue);

  if (dateValue === undefined || !dateObj.isValid()) {
    throw new Error('Invalid date');
  }

  return dateObj.valueOf();
}
